import { Layout } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AppContext";
import MainContainer from "../layout/MainContainer";
import "./ControlCenter.css";

export default function ControlCenter() {
  const navigate = useNavigate();
  const { role } = useContext(AppContext);
  const [toggleSideBar, setToggleSideBar] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // if role is telecom_user, then redirect to signal-map
    if (role === "telecom_user") {
      navigate("/signal-map");
    } else {
      // navigate("/control-center/gardens");
    }
  }, [navigate, role]);

  return (
    <Layout>
      <MainContainer toggleSideBar={toggleSideBar} setToggleSideBar={setToggleSideBar} />
    </Layout>
  );
}
